import axios from 'axios';

// สร้าง Axios instance ที่มี baseURL และ header เริ่มต้น
const api = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ฟังก์ชันสำหรับลงทะเบียนผู้ใช้
export const registerHeadler = async (user) => {
  try {
    return await api.post('/register', user);
  } catch (error) {
    console.error('Register error:', error);
    throw error;
  }
};

// backward-compatible alias: previous files/imports expect `registerHandler`
export const registerHandler = registerHeadler;

// ฟังก์ชันสำหรับ login
export const LoginHeadler = async (user, options = {}) => {
  try {
    return await api.post('/login', user, options);
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// ฟังก์ชันสำหรับดึงข้อมูลผู้ใช้ที่ login อยู่ (สำหรับ client)
export async function currentUser(authtoken) {
  try {
    return await api.post(
      '/current-user',
      {},
      { headers: { authtoken } }
    );
  } catch (error) {
    console.error('Current user error:', error);
    throw error;
  }
}

// ฟังก์ชันสำหรับดึงข้อมูล admin
export async function currentAdmin(authtoken) {
  try {
    return await api.post(
      '/current-admin',
      {},
      { headers: { authtoken } }
    );
  } catch (error) {
    console.error('Current admin error:', error);
    throw error;
  }
}

// ฟังก์ชันสำหรับดึง token ของผู้ใช้
export async function getUserToken() {
  try {
    const response = await api.post(
      '/getUserToken',
      {},
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      console.error('API request failed with status:', response.status);
      return null;
    }
  } catch (error) {
    console.error('Error while fetching token:', error);
    return null;
  }
}
